import { COLLECTIONS_CACHE_ACTIONS } from '../../constants/actions';
import { CollectionsShowResponse } from '../../types/api/CollectionsShowTypes';

export const setCollectionsCache = (collections: Array<CollectionsShowResponse>) => ({
  type: COLLECTIONS_CACHE_ACTIONS.SET_COLLECTIONS_CACHE,
  collections: collections,
});

export const addToCollectionsCache = (collection: CollectionsShowResponse) => ({
  type: COLLECTIONS_CACHE_ACTIONS.ADD_TO_COLLECTIONS_CACHE,
  collection: collection,
})
